export default __webpack_public_path__ + "assets/img/Search.c14d928c.svg";